import React from "react";
import { motion } from "framer-motion";
import { Flame, BookOpen, PenTool } from "lucide-react";
import { Badge } from "@/components/site/primitives";
import { fadeUp } from "@/lib/motion";
import { CURRENT_USER } from "@/data";
import { useAuth } from "@/lib/useAuth";

export default function WelcomeHeader() {
  const { user } = useAuth();
  const name = user?.displayName || user?.name || user?.username || CURRENT_USER.name;
  const stats = user?.stats || CURRENT_USER.stats;
  return (
    <section className="u-container pt-10 md:pt-14" data-testid="home-welcome">
      <motion.p variants={fadeUp} custom={0} initial="hidden" animate="show" className="u-eyebrow mb-3">
        <span className="inline-block h-1.5 w-1.5 rounded-full bg-coral" /> Your reading nook
      </motion.p>
      <motion.h1 variants={fadeUp} custom={1} initial="hidden" animate="show" className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
        Welcome back, {name}
      </motion.h1>
      <motion.p variants={fadeUp} custom={2} initial="hidden" animate="show" className="mt-2 text-sm text-subtle sm:text-base">
        What are you in the mood to read?
      </motion.p>
      <motion.div variants={fadeUp} custom={3} initial="hidden" animate="show" className="mt-4 flex flex-wrap items-center gap-2.5">
        <Badge tone="coral" className="gap-1.5"><BookOpen className="h-3.5 w-3.5" /> {stats.booksRead} books read</Badge>
        <Badge tone="yellow" className="gap-1.5"><PenTool className="h-3.5 w-3.5" /> {stats.writing} stories in progress</Badge>
        <Badge tone="sage" className="gap-1.5"><Flame className="h-3.5 w-3.5" /> {stats.streak}-day streak</Badge>
      </motion.div>
    </section>
  );
}
